module.exports = __webpack_public_path__ + "img/part5-5.29ff1361.png";